import React from "react";
import {useParams} from "react-router-dom";
import { useEffect, useState} from "react";
import axios from "axios";
import Loading from "../Components/MinComponents/Loading";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import Form from "../Components/Form";

const Product = ()=>{
    const {id}=useParams();
    const [state, setState]=useState(null);

    const [activeForm, isFormActive]=useState(false);

    //change form 
    const changeForm=()=>{
        isFormActive(!activeForm);
    }


    //fetching data from api
    useState(async ()=>{
        let url=`${process.env.REACT_APP_BASE}/product/${id}`

        let wow = await axios.get(url);
        console.log(wow.data.product);
        setState(wow.data.product);
    },[id]);
return (
  <> 
    {activeForm && <Form data={state} toggleModal={changeForm}/>}
    {state===null && <Loading/>}
    {
    state 
    &&
        <div className="bg-white ">
            <div className="pt-6 grid grid-cols-1 md:grid-cols-2">
                    {/* tesponsive images */}
                    {
                        <div className="mt-6 max-w-2xl lg:gap-x-8 lg:px-8">
                            <Carousel
                                showArrows={true} // Show navigation arrows
                                infiniteLoop={true} // Enable infinite loop
                                swipeable={true} // Enable swiping on mobile devices
                                emulateTouch={true} // Emulate touch events on desktop for testing
                                showThumbs={false} // Hide thumbnails
                                showStatus={false} // Hide status indicators
                            >
                                {state.images.map((image, index) => (
                                <div key={index} className="aspect-square">
                                    <img
                                    src={image}
                                    alt={`Image ${index + 1}`}
                                    className="w-full h-full object-cover object-center"
                                    />
                                </div>
                                ))}
                            </Carousel>
                        </div>
                    }
    
                <div className="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-1 lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
                    <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                        <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-5xl">{state.name}</h1>
                    </div>

                    <div className="mt-6 lg:row-span-3">
                        <h2 className="sr-only">Product information</h2>
                        <p className="text-3xl tracking-tight text-gray-900">Rs. {state.price}</p>
                            <div className="mt-10">

                                <fieldset className="mt-4">
                                <legend className="text-center font-bold">Delivery Time</legend>

                                    <div className="grid grid-cols-3 gap-4 sm:grid-cols-3 lg:grid-cols-3">

                                        <label className="group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6 cursor-pointer bg-white text-gray-900 shadow-sm">
                                            <input type="radio" name="size-choice" value="L" className="sr-only" aria-labelledby="size-choice-4-label"/>
                                                <span id="size-choice-4-label">{state.delivery} days</span>

                                                <span className="pointer-events-none absolute -inset-px rounded-md" aria-hidden="true"/>
                                        </label>
                                        <label className="group relative flex items-center justify-center rounded-md font-semibold py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6 cursor-pointer bg-white text-gray-900 shadow-sm">
                                            <input type="radio" name="size-choice" value="L" className="sr-only" aria-labelledby="size-choice-4-label"/>
                                                <span id="size-choice-4-label">to</span>

                                                <span className="pointer-events-none absolute -inset-px rounded-md" aria-hidden="true"/>
                                        </label>
                                        <label className="group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6 cursor-pointer bg-white text-gray-900 shadow-sm">
                                            <input type="radio" name="size-choice" value="L" className="sr-only" aria-labelledby="size-choice-4-label"/>
                                                <span id="size-choice-4-label">{state.delivery+5} days</span>

                                                <span className="pointer-events-none absolute -inset-px rounded-md" aria-hidden="true"/>
                                        </label>
                                    </div>
                                </fieldset>
                            </div>

                            <div className="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" onClick={()=>{isFormActive(true)}}>Contact Us</div>
                    </div>

                    <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-gray-200 lg:pb-16 lg:pr-8 lg:pt-6">

                        <div>
                            <h3 className="text-lg font-bold">Description</h3>

                            <div className="space-y-6">
                                <p className="text-base text-black text-md">{state.description}</p>
                            </div>
                        </div>

                        <div className="mt-10 ">

                            <div className="mt-4">
                                <ul role="list" className="space-y-2 pl-4 text-sm">
                                    <li className="text-gray-800 text-lg"> Category : <span className="font-semibold text-black"> {state.category.toUpperCase()} </span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

  </>
)
}
export default Product